import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import accountPropTypes from '../../../states/accounts/propTypes';
import AccountPickerHeader from './AccountPickerHeader';
import PickerPagingView from '../PickerPagingView/PickerPagingView';
import AccountPickerFavouritesView from './AccountPickerFavouritesView';
import { pickerLayoutStyles } from '../../PickerLayoutStyles';
import { ACCOUNT_PICKER_LAYOUT, PAYEE_PICKER_LAYOUT } from '../../constants';
import accountPickerContent, { contentPropTypes } from './AccountPicker.content';
import withContent from '../../../containers/withContent';
import AccountPickerToggleAccountsView from './AccountPickerToggleAccountsView';
import { getFavouriteAccountsForPicker } from '../../../states/favourites/selectors';
import {
	getPageLoading,
	getAccountsForCurrentPage,
	getCurrentPageInfo,
	getErrorFlag,
	getSearchText,
	getAccountsNeverFetched,
	getPagingLayoutType,
	getShowFavouritesToggleInPayeePicker,
	isFavouritesEnabled,
	getIsAccountsSearchFilterOn,
} from '../../../states/accountPaging/selectors';
import { getSelectedFromAccount } from '../../../states/payeeSelector/selectors';
import { swiftChars } from '../../../utils/payeeUtils';
import { getPage } from '../../../states/accountPaging/actions';
import { getPage as getPaymentsPage } from '../../../states/page/selectors';
import { pages } from '../../../states/page/actions';
import { setIsSelectingLCVFromAccount } from '../../../states/accountPaging/actions';

const mapState = (state) => ({
	currentPageInfo: getCurrentPageInfo(state),
	pageLoading: getPageLoading(state),
	accounts: getAccountsForCurrentPage(state),
	error: getErrorFlag(state),
	searchText: getSearchText(state),
	accountsNeverFetched: getAccountsNeverFetched(state),
	fromAccount: getSelectedFromAccount(state),
	layoutType: getPagingLayoutType(state),
	favourites: getFavouriteAccountsForPicker(state),
	showFavouritesToggleInPayeePicker: getShowFavouritesToggleInPayeePicker(state),
	isFavouritesEnabled: isFavouritesEnabled(state),
	isSearchFilterOn: getIsAccountsSearchFilterOn(state),
	paymentsPage: getPaymentsPage(state),
});

const mapDispatch = (dispatch) => ({
	initializeGetPage: (page) => dispatch(getPage(page)),
	setIsSelectingLCVFromAccount: (value) => dispatch(setIsSelectingLCVFromAccount(value)),
});

class AccountPicker extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showFavourites: props.favourites.length > 0,
			showListView: false,
		};

		this.showFavourites = this.showFavourites.bind(this);
		this.showAllAccounts = this.showAllAccounts.bind(this);
		this.handleListViewToggle = this.handleListViewToggle.bind(this);
		this.handleSearchTextChanged = this.handleSearchTextChanged.bind(this);
		this.renderAccountPicker = this.renderAccountPicker.bind(this);
	}

	componentDidMount() {
		const { showFavourites } = this.state;
		const { accountsNeverFetched, initializeGetPage, layoutType, paymentsPage, setIsSelectingLCVFromAccount } =
			this.props;
		if (!showFavourites && accountsNeverFetched) {
			initializeGetPage(1);
		}
		if (layoutType === PAYEE_PICKER_LAYOUT) {
			initializeGetPage(1);
		}
		setIsSelectingLCVFromAccount(paymentsPage === pages.FasterPaymentsAccountPicker);
	}
	componentWillReceiveProps(nextProps) {
		const { searchText } = this.state;
		const { paymentsPage, setIsSelectingLCVFromAccount } = this.props;

		if (!nextProps.isFavouritesEnabled) {
			this.setState({
				showFavourites: false,
			});
		}
		if (!searchText && nextProps.searchText) {
			this.setState({
				showFavourites: false,
			});
		}
		if (paymentsPage !== nextProps.paymentsPage)
			setIsSelectingLCVFromAccount(paymentsPage === pages.FasterPaymentsAccountPicker);
	}

	showFavourites() {
		const { onSearchTextChanged, isSearchFilterOn, onPageChanged, searchText } = this.props;
		this.setState({ showFavourites: true });
		if (searchText) {
			onSearchTextChanged('');
		}
		if (isSearchFilterOn) {
			onPageChanged(1);
		}
	}

	showAllAccounts() {
		this.setState({ showFavourites: false }, () => {
			const { accountsNeverFetched, onPageChanged } = this.props;
			if (accountsNeverFetched) {
				onPageChanged(1);
			}
		});
	}

	handleListViewToggle(value) {
		this.setState({
			showListView: value,
		});
	}

	handleSearchTextChanged(text) {
		const { onSearchTextChanged, isSearchFilterOn, onPageChanged } = this.props;
		onSearchTextChanged(swiftChars(text));
		if (isSearchFilterOn && !text) {
			onPageChanged(1);
		}
		this.setState({
			showFavourites: false,
		});
	}
	renderAccountPicker() {
		const {
			favourites,
			pageLoading,
			accounts,
			currentPageInfo,
			onSelectAccount,
			error,
			onRetry,
			searchText,
			accountsNeverFetched,
			onPageChanged,
			layoutType,
			handleFavouriteIconClick,
			getIsAccountSelected,
			isBootStrapInProgress,
			isFavouritesEnabled,
			listViewSelected,
		} = this.props;

		const { currentPage, totalNumberOfPages } = currentPageInfo;
		const { showFavourites, showListView } = this.state;
		const isListView = layoutType === ACCOUNT_PICKER_LAYOUT ? showListView : listViewSelected;

		if (showFavourites) {
			return (
				<AccountPickerFavouritesView
					favourites={favourites}
					listViewSelected={isListView}
					onAccountClick={onSelectAccount}
					onFavouriteIconClick={handleFavouriteIconClick}
					getIsAccountSelected={getIsAccountSelected}
					layoutType={layoutType}
				/>
			);
		}

		return (
			<PickerPagingView
				currentPage={currentPage}
				totalNumberOfPages={totalNumberOfPages}
				pageLoading={pageLoading}
				onPageChange={onPageChanged}
				accounts={accounts}
				listViewSelected={isListView}
				numberOfFavourites={favourites.length}
				onFavouriteIconClick={isFavouritesEnabled && handleFavouriteIconClick}
				onAccountClick={onSelectAccount}
				error={error}
				onRetry={onRetry}
				searchText={searchText}
				accountsNeverFetched={accountsNeverFetched}
				layoutType={layoutType}
				getIsAccountSelected={getIsAccountSelected}
				isBootStrapInProgress={isBootStrapInProgress}
			/>
		);
	}

	render() {
		const { pageLoading, searchText, layoutType, onSearchTextSubmit, content, showFavouritesToggleInPayeePicker } =
			this.props;

		const { showFavourites, showListView } = this.state;
		return (
			<div className={pickerLayoutStyles}>
				{layoutType === ACCOUNT_PICKER_LAYOUT && (
					<AccountPickerHeader
						onToggleListView={this.handleListViewToggle}
						onShowFavourites={this.showFavourites}
						onShowAllAccounts={this.showAllAccounts}
						onSearchTextChange={this.handleSearchTextChanged}
						searchText={searchText}
						listViewSelected={showListView}
						showFavourites={showFavourites}
						onSearchTextSubmit={onSearchTextSubmit}
						pageLoading={pageLoading}
					/>
				)}
				{showFavouritesToggleInPayeePicker && (
					<AccountPickerToggleAccountsView
						onShowFavourites={this.showFavourites}
						onShowAllAccounts={this.showAllAccounts}
						showFavourites={showFavourites}
						content={content}
					/>
				)}
				{this.renderAccountPicker()}
			</div>
		);
	}
}

AccountPicker.propTypes = {
	favourites: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	pageLoading: PropTypes.bool.isRequired,
	accounts: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	currentPageInfo: PropTypes.shape({
		currentPage: PropTypes.number.isRequired,
		totalNumberOfPages: PropTypes.number.isRequired,
	}),
	onSelectAccount: PropTypes.func.isRequired,
	onRetry: PropTypes.func.isRequired,
	onSearchTextChanged: PropTypes.func.isRequired,
	searchText: PropTypes.string.isRequired,
	accountsNeverFetched: PropTypes.bool.isRequired,
	error: PropTypes.bool.isRequired,
	onPageChanged: PropTypes.func.isRequired,
	onSearchTextSubmit: PropTypes.func.isRequired,
	layoutType: PropTypes.string.isRequired,
	handleFavouriteIconClick: PropTypes.func.isRequired,
	content: PropTypes.shape(contentPropTypes),
	getIsAccountSelected: PropTypes.func,
	isBootStrapInProgress: PropTypes.bool.isRequired,
	initializeGetPage: PropTypes.func.isRequired,
	showFavouritesToggleInPayeePicker: PropTypes.bool.isRequired,
	isFavouritesEnabled: PropTypes.bool.isRequired,
	isSearchFilterOn: PropTypes.bool.isRequired,
	listViewSelected: PropTypes.bool.isRequired,
};

export { AccountPicker };
const contentWrapper = withContent({ content: accountPickerContent })(AccountPicker);
export default connect(mapState, mapDispatch)(contentWrapper);
